export enum CheckoutLoginPostMessageName {
    checkoutLoginHeightChange = 'checkoutLoginHeightChange',
    checkoutLoginSuccessful = 'checkoutLoginSuccessful',
    checkoutContinueAsGuest = 'checkoutContinueAsGuest',
}
